module.exports = __webpack_public_path__ + "assets/49fc0dcb81aa096df2462c5a5216a470.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/win/Level2_WinKP35V1_11.mp3
 ** module id = 505
 ** module chunks = 0
 **/